import { HashRouter } from "react-router-dom"
import { GenericWrapper, uiKitConfig } from "@cakemail-org/ui-components-v2"
import AssetManager from "../container/assetManager"
import {
    TExportedCampaignsApp,
    TExportedEmailAPIContainer,
    TExportedExportsApp,
    TExportedFormsApp,
    TExportedOnboardingContainer,
    TExportedPopupsApp,
    TExportedSideMenu,
    TExportedSystemEmailsContainer,
    TExportedTemplatesContainer,
    TExportedUsersApp,
    TExportedAutomationsApp,
    TExportedABTestsApp,
    TExportedPagesApp
} from "./types"
import LocizeInitializer from "../components/locize"
import SystemEmails from "../container/systemEmails"
import { errorHandler } from "../utils/api"
import { EmailAPI } from "../container/emailAPI"
import moment from "moment"
import { Dashboard } from "../container/dashboard"
import { Onboarding } from "../container/onboarding"
import { AppMenu } from "../components/AppMenu"
import { ErrorBoundary } from "@sentry/react"
import { ContentErrorSection } from "../components/contentTemplate/contentSectionError"
import Forms from "../container/forms"
import PublicForm from "../container/public/forms"
import { Campaigns } from "../container/campaigns"
import SuppressionList from "../container/suppressionList"
import { Exports } from "../container/exports"
import '../assets/scss/index.scss'
import { Lists } from "../container/lists"
import Popups from "../container/popups"
import Users from "../container/users"
import Automations from "../container/automations"
import ABTests from "../container/abTests"
import FileManager from "../container/fileManager"
import Pages from "../container/pages"
import Templates from "../container/templates"


export function TemplatesApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedTemplatesContainer) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} userBrandObj={userBrandObj} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl}>
                <Templates />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function SystemEmailsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedSystemEmailsContainer) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} userBrandObj={userBrandObj} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <SystemEmails />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function EmailAPIApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedEmailAPIContainer) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} userBrandObj={userBrandObj} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <EmailAPI />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function DashboardApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedEmailAPIContainer) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} userBrandObj={userBrandObj} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Dashboard />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function OnboardingApp({ account, brandObj, user, proxyUrl, setUser, onOnboardingCompleted, userBrandObj }: TExportedOnboardingContainer) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Onboarding setUser={setUser} onOnboardingCompleted={onOnboardingCompleted} />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function SideMenuApp({ account, brandObj, user, proxyUrl, onLogout, showTagLibraryDialog, setUser, userBrandObj }: TExportedSideMenu) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <AppMenu onLogout={onLogout} showTagLibraryDialog={showTagLibraryDialog} setUser={setUser} />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}


export function FormsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedFormsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Forms />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function PublicFormApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedFormsApp) {
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <PublicForm />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function CampaignsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedCampaignsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Campaigns />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function SuppressionListApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedExportsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <SuppressionList />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function ExportsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedExportsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Exports />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function ListsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedExportsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Lists />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function PopupsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedPopupsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Popups />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function PagesApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedPagesApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Pages />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function UsersApp({ account, brandObj, user, proxyUrl, userBrandObj, setAccount }: TExportedUsersApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Users setAccount={setAccount} />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function AutomationsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedAutomationsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <Automations />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function ABTestsApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedABTestsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <ABTests />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}

export function FileManagerApp({ account, brandObj, user, proxyUrl, userBrandObj }: TExportedABTestsApp) {
    uiKitConfig.ERROR_HANDLER = errorHandler
    if (user)
        moment.locale(user.language?.replace("_", "-") || "en-US")
    return <ErrorBoundary fallback={<ContentErrorSection small />}>
        <HashRouter>
            <GenericWrapper account={account} brandObj={brandObj} userBrandObj={userBrandObj} user={user} LocizeInitializer={LocizeInitializer} proxyUrl={proxyUrl} >
                <FileManager />
            </GenericWrapper>
        </HashRouter>
    </ErrorBoundary>
}